module.exports = __webpack_public_path__ + "img/data-center07.f10a1f0e.png";